

<template>
<div>
     <div class="currentSize">
        <el-row  style=" margin-top: 20px">
            <div style="font-size:24pt;margin-bottom:10px">武汉市建设工程施工图设计文件送审表</div>
             <div style="font-size:14pt;margin-bottom:20px">（建筑设计）</div>
              <div style="font-size:14pt;margin-bottom:20px">
                  <span style="width:400px;display:inline-block;text-align: left;">项目编号：</span>
                  <span style="width:400px;">管理权属：</span>
              </div>
             <el-form label-width="110px" ref="refForm" :model="form.data" label-position="right">
                <table width="920px" class="confirmTable" style="margin:0 auto" cellspacing="0" border="1">
                    <tr>
                         <td width="115">工程名称</td>
                        <td colspan="3" width="345">{{form.data.name}}</td>
                        <td width="115">工程地址</td>
                        <td colspan="3" width="345">{{form.data.location}}</td>
                    </tr>
                    <tr>
                        <td width="410"  colspan="4" style="text-align:left;text-indent:10pt">建设工程规划许可证编号：</td>
                        <td width="410"  colspan="4" style="text-align:left;text-indent:10pt">建筑核位红线图档案号：</td>
                    </tr>
                    <tr>    
                        <td width="115">建设单位</td>
                        <td width="345" colspan="3">{{form.data.constructCorp}}</td>
                        <td width="115">联系人</td>
                        <td width="115">{{form.data.contactPersonTel}}</td>
                        <td width="115">联系电话</td>
                        <td width="115">{{form.data.contactPerson}}</td>
                    </tr>
                    <tr>
                        <td width="115" rowspan="2">勘察设计单位</td>
                        <td colspan="3" width="345" rowspan="2">{{form.data.surveyCorp}}</td>
                        <td width="115">资质等级</td>
                        <td width="115"></td>
                        <td width="115">证书编号</td>
                        <td width="115">15736950500</td>
                    </tr>
                     <tr>
                        <td width="115">联系人</td>
                        <td width="115"></td>
                        <td width="115">联系电话</td>
                        <td width="115"></td>
                    </tr>
                   <tr>
                        <td width="115" rowspan="3">勘察设计单位执业人员</td>
                        <td width="115">执业专业</td>
                        <td width="115" >建筑</td>
                        <td width="115">结构</td>
                        <td width="115">给排水</td>
                        <td width="115">电气</td>
                        <td width="115">暖通</td>
                        <td width="115">消防</td>
                    </tr>
                      <tr>
                        <td width="115" >姓名</td>
                        <td width="115" ></td>
                        <td width="115"></td>
                        <td width="115"></td>
                        <td width="115"></td>
                        <td width="115"></td>
                        <td width="115">15736950500</td>
                    </tr>
                     <tr>
                        <td width="115" ></td>
                        <td width="115" >勘察设计单位</td>
                        <td width="115">{{form.data.surveyCorp}}</td>
                        <td width="115">资质等级</td>
                        <td width="115"></td>
                        <td width="115">证书编号</td>
                        <td width="115">15736950500</td>
                    </tr>
                    <!-- <tr>
                        <td width="115">联系人</td>
                        <td width="115">联系人</td>
                        <td width="115"></td>
                        <td width="115">联系电话</td>
                        <td width="115"></td>
                        <td width="115">联系人</td>
                        <td width="115"></td>
                        <td width="115">联系电话</td>
                    </tr> -->
                </table>
             </el-form>
               <el-form style="margin-top:-1px">
                <table width="920px" class="confirmTable" style="margin:0 auto" cellspacing="0" border="1">
                    <tr>
                        <td colspan="8">单体信息</td>
                    </tr>
                    <tr>
                        <td width="50">序号</td>
                        <td width="90">子项名称</td>
                        <td width="100">地上层数</td>
                        <td width="100">地下层数</td>
                        <td width="100">建筑高度</td>
                        <td width="131">吊车吨位</td>
                        <td width="80">跨度</td>
                    </tr>
                    <tr v-for="(item,index) in projectsTable.data">
                        <td width="50">{{index}}</td>
                        <td width="90">{{item.projectName}}</td>
                        <td width="100">{{item.agroundFloors}}</td>
                        <td width="100">{{item.undergroundFloors}}</td>
                        <td width="100">{{item.high}}</td>
                        <td width="131">0</td>
                        <td width="80">0</td>
                        <!-- <td width="110">0</td> -->
                    </tr>
                </table> 
             </el-form>
        </el-row>
    </div>
</div>  
</template>
<script>
export default {
   data(){
        return {
        a1: "",
        a2: "",
        xuke: false,
        xukefou: false,
        // constructCorp: "",  
        // contactPerson: "",
        // contactPersonTel: "",
        form: {     
            data: {
            displayProjectName: "",
            projectSupType: "",
            // projectSupTypeName: "",
            location: '', //这个地方市/区
            area: "",
            projectAddress: "",
            deliverDate: "",
            constructCorp: "",  
            contactPerson: "",
            contactPersonTel: "",
            fdNumber: "PT000123",
            name: "",
            customerID: "",
            customerName: "",
            surveyCorp: "",
            surveyCorpGrade: "",
            designCorp: "",
            designCorpGrade: "",
            designCorpProjecter: "",
            designCorpTel: "",
            airDefenseDesignCorp: "", //人防勘察设计单位
            airDefenseDesignCorpGrade: "", //人防勘察设计单位等级
            yttaskID: "", //勘前报审编号
            gongJianTaskId: "", //GongJianTaskId
            isGuiHua: "", //IsGuiHua
            guiHuaTaskId: "", //GuiHuaTaskId
            applyExplain: "" //报审说明
                },
            },
            projectsTable:{
                data:[]
            },
      url: {
        projects:'/draw/projects',
         task:'/draw/tasks',
        regioninfo: "/censor/regioninfo"
         },
     
    };
   },
   mounted(){
    // this.getParams();
    let id = this.$route.query.id;   //获取router中的id
    
   },
   methods: {
        getParams () {
        // 取到路由带过来的参数
        let id = this.$route.query.id;
        this.query(id);
      },
      query(id){
        this.taskID = id;
        this.queryCensorTask(id);
        this.queryProjects();
      },
     queryCensorTask(id){//查询task
        this.$http.get(
          this.url.task+"/detail?id="+id,
        ).then((res) => {
          this.form.data = res.data.result;
        })
      },
      queryProjects(){
        // this.projectsTable.loading = true;
        this.$http.get(
          this.url.projects +"?"
          +"taskID="+this.taskID
        ).then((res) => {
          if (res.ok) {
            this.projectsTable.data = res.data.result.data;
          } else {
            this.$message.error('查询失败，请联系管理员');
          }
        },(error)=>{
          this.$message.error('查询失败，请联系管理员');
        })
      },
    
    }
};
</script>
<style scoped>
@import "../../../styles/css/confirm.css";   
</style>





// WEBPACK FOOTER //
// src/views/constructionUnit/task/confirm.vue